<template>
  <div style="width: 100%" class="fill-height">
    <v-container>
      <v-row class="justify-end pt-3 pb-1 pr-3">
        <v-btn class="add-discount-btn" elevation="0" @click="openaddDiscount">
          <v-icon small class="mr-1">mdi-plus</v-icon>
          Dodaj popust
        </v-btn>
      </v-row>
      <v-row v-if="listView" class="justify-center">
        <v-col cols="12" sm="11" lg="11" :class="['px-0']">
          <div class="discount-rows-body">
          <v-card
            v-for="(discount, i) in sortedDiscounts"
            :key="i"
            :class="['discount-card', discount.active === true ? 'status-ok' : 'status-inactive']"
          >
            <v-row class="ma-0 discount-row">
              <v-col
                cols="12"
                sm="5"
                md="3"
                lg="3"
                style="min-width: 100px; max-width: 100%"
                :class="[densityPadding, 'flex-grow-1']"
              >
                <div class="caption grey--text">Naziv popusta</div>
                <div
                  class="text-subtitle-1 one-liner-text font-weight-medium"
                  @mouseover="hoverOver(`hover-${discount.id}`, discount)"
                  @mouseleave="discount[`hover-${discount.id}`] = false"
                  :id="`hover-${discount.id}`"
                  :ref="`hover-${discount.id}`"
                >
                  {{ capitalizeFirst(discount.name) }}
                </div>
                <v-tooltip v-model="discount[`hover-${discount.id}`]" bottom>
                  <template v-slot:activator="{ on }">
                    <div v-on="on"></div>
                  </template>
                  <div style="max-width: 300px">
                    {{ capitalizeFirst(discount.name) }}
                  </div>
                </v-tooltip>
              </v-col>
              <v-col
                v-if="!$vuetify.breakpoint.smAndDown"
                cols="12"
                sm="3"
                md="2"
                lg="2"
                :class="[densityPadding]"
              >
                <div class="caption grey--text">Vrsta popusta</div>
                <div class="font-weight-medium">{{ translateType(discount.type) }}</div>
              </v-col>

              <v-col
                v-if="!$vuetify.breakpoint.smAndDown && discount.type !== 'MANUAL'"
                cols="12"
                sm="3"
                md="2"
                lg="2"
                :class="[densityPadding]"
              >
                <div class="caption grey--text">
                  Iznos popusta
                </div>
                <div class="font-weight-medium" v-if="discount.type == 'RATE'">
                  {{ discount.rate / 100 }} %
                </div>
                <div class="font-weight-medium" v-if="discount.type == 'AMOUNT'">
                  {{ (discount.amount / 100) | money(0, currency) }}
                </div>
              </v-col>
              <v-col
                v-if="!$vuetify.breakpoint.smAndDown"
                cols="12"
                sm="3"
                md="2"
                lg="2"
                :class="[densityPadding]"
              >
                <div class="caption grey--text">Status</div>
                <div
                  class="font-weight-medium"
                  :class="[
                    discount.active === true
                      ? 'status-text-active'
                      : 'status-text-inactive'
                  ]"
                >
                  {{ showActivity(discount.active) }}
                </div>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="2"
                lg="2"
                :class="[densityPadding]"
              >
                <div class="caption grey--text text-center">Akcije</div>
                <div class="d-flex align-start justify-center">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="mt-0 pt-0"
                        :x-small="density === 'greater'"
                        v-on="on"
                        v-bind="attrs"
                        icon
                        color="#3989C9"
                        @click="openEditDiscountForm(discount)"
                        @keypress.enter="openEditDiscountForm(discount)"
                      >
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                    </template>
                    <span>Uredi popust</span>
                  </v-tooltip>
                </div>
              </v-col>
            </v-row>
          </v-card>
          </div>
        </v-col>
      </v-row>
      <v-row
        v-else
        class="d-flex justify-center align-center flex-wrap fill-height ma-0 pa-0"
      >
        <v-card
          class="discount-grid-card ma-4"
          v-for="(discount, i) in sortedDiscounts"
          :key="i"
          hover
          height="250"
          width="250"
        >
          <div
            class="discount-grid-header"
            :class="[
              discount.active === true
                ? 'status-active-header'
                : 'status-inactive-header'
            ]"
          >
            <div class="discount-icon-wrapper">
              <v-icon size="64" color="white">mdi-sale</v-icon>
            </div>
          </div>
          <div class="discount-grid-content">
            <h3 class="discount-grid-title one-liner-text">
              {{ capitalizeFirst(discount.name) }}
            </h3>
            <p class="discount-grid-type one-liner-text">
              {{ translateType(discount.type) }}
            </p>
            <p
              class="discount-grid-status one-liner-text"
              :class="[
                discount.active === true
                  ? 'status-text-active'
                  : 'status-text-inactive'
              ]"
            >
              Status: {{ showActivity(discount.active) }}
            </p>
          </div>
          <v-divider></v-divider>
          <v-card-actions class="discount-grid-actions">
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-on="on"
                  v-bind="attrs"
                  icon
                  color="#3989C9"
                  @click="openEditDiscountForm(discount)"
                  @keypress.enter="openEditDiscountForm(discount)"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Uredi popust</span>
            </v-tooltip>
          </v-card-actions>
        </v-card>
      </v-row>
      <infinite-loading
        ref="InfiniteLoading"
        @infinite="infiniteHandler"
        spinner="waveDots"
      >
        <div slot="no-more" class="text--secondary font-italic"></div>
        <div slot="no-results" class="text--secondary font-italic"></div>
      </infinite-loading>
    </v-container>
    <add-discount ref="addDiscount" @success="refreshDiscounts"></add-discount>
    <edit-discount
      ref="editDiscount"
      @success="refreshDiscounts"
    ></edit-discount>
  </div>
</template>
<script>
import { df } from '@/plugins/firebase'
import { clone } from '@/plugins/utils'
import state from '@/state'
import addDiscount from '@/modules/company/components/discount/AddDiscount'
import editDiscount from '@/modules/company/components/discount/EditDiscount'
import InfiniteLoading from 'vue-infinite-loading'
import flow from '@/mixins/flow'
import applicationSettings from '@/mixins/applicationSettings' // don't move.. detaches firebase listeners
import barcodeChecker from '@/mixins/barcodeChecker'
export default {
  inject: ['showLoader', 'confirm', 'confirmClose', 'hideLoader'],
  mixins: [flow, applicationSettings, barcodeChecker],
  components: { addDiscount, InfiniteLoading, editDiscount },
  data: () => ({
    loading: false,
    lastiItem: false,
    options: {},
    pagination: {
      itemsPerPage: 10, // TODO: change to 30 after testing.
      page: 1
    },
    headers: [],
    discounts: [],
    sortedDiscounts: [],
    avatarSize: 120,
    lastVisible: '',
    listeners: [],
    newItem: false,
    multiplier: 0,
    currency: 'EUR'
  }),
  mounted () {
    this.currency = 'HRK'
    if (Date.now() / 1000 > 1672527599) {
      this.currency = 'EUR'
    }
    this.getMultiplier()
  },
  computed: {
    listView () {
      return state.isListView()
    }
  },
  watch: {
    listView (nv, ov) {
      if (nv !== ov) {
        if (this.$refs.InfiniteLoading) {
          this.$refs.InfiniteLoading.stateChanger.reset()
        }
      }
    },
    companyId (nv, ov) {
      if (nv !== ov) {
        this.detachListeners()
        this.items = []
        if (this.$refs.InfiniteLoading) {
          this.$refs.InfiniteLoading.stateChanger.reset()
        }
      }
    },
    search () {
      this.lastVisible = ''
      this.items = []
      if (this.$refs.InfiniteLoading) {
        this.$refs.InfiniteLoading.stateChanger.reset()
      }
    }
  },
  methods: {
    showActivity (active) {
      if (active) {
        return 'Aktivan'
      } else {
        return 'Neaktivan'
      }
    },
    translateType (type) {
      switch (type) {
        case 'RATE':
          return 'Postotni popust'
        case 'AMOUNT':
          return 'Apsolutni popust'
        case 'MANUAL':
          return 'Ručni upis'
      }
    },
    capitalizeFirst (name) {
      return name.charAt(0).toUpperCase() + name.slice(1)
    },
    hoverOver (ref, item) {
      const container = this.$refs[ref]
      if (!container || !container[0]) return
      if (container[0].associateHeight < container[0].scrollHeight) {
        item[ref] = true
      }
    },
    openaddDiscount () {
      this.$refs.addDiscount.open()
    },
    openEditDiscountForm (discount) {
      this.$refs.editDiscount.open(discount)
    },
    refreshDiscounts (discount) {
      // if (discount.action === 'ADD') {
      //   this.newItem = true
      //   this.items.unshift(
      //     { ...item, ...{ status: 'PROCESSING' } }
      //   )
      //   this.$vuetify.goTo(0)
      // } else if (item.action === 'EDIT') {
      //   this.items = this.items.map(_item => {
      //     if (_item.id === item.id) {
      //       _item.name = item.name
      //       _item.status = 'PROCESSING'
      //     }
      //     return _item
      //   })
      // }
    },
    modifyItems (change) {
      if (change.type === 'added') {
        if (this.discounts.some(discount =>
          (discount.id === change.doc.data().id) ||
          (discount.name.toLowerCase() === change.doc.data().name)
        )) {
          this.discounts = this.discounts.map(discount => {
            let ret = discount
            if (((discount.id === change.doc.data().id) || (discount.name === change.doc.data().name.toLowerCase())) && this.newItem) {
              ret = change.doc.data()
            }
            return { ...ret, ...{ [`hover-${change.doc.data().id}`]: false } }
          })
        } else {
          this.discounts.push({ ...change.doc.data(), ...{ [`hover-${change.doc.data().id}`]: false } })
        }
      }
      if (change.type === 'modified') {
        this.discounts = this.discounts.map(discount => {
          let ret = discount
          if (discount.id === change.doc.data().id) {
            ret = change.doc.data()
          }
          return { ...ret, ...{ [`hover-${change.doc.data().id}`]: false } }
        })
      }
      this.sortedDiscounts = clone(this.discounts.sort((a, b) => a.name.localeCompare(b.name)))
    },
    infiniteHandler ($state) {
      const search = 'name'
      const where = this.search ? this.search.toLowerCase() : ''

      let query = df.collection(`companies/${state.getCurrentCompany().id}/discounts`)
        .orderBy(search, 'asc')
        .limit(10)
        .startAfter(this.lastVisible)
      if (where) {
        query = query.where(search, '>=', where).where(search, '<=', where + '\uf8ff')
      }

      console.log('query', query)
      const listener = query
        .onSnapshot((doc) => {
          doc.docChanges().forEach(change => {
            this.modifyItems(change)
          })
          if (doc && !doc.empty) {
            if (doc.docs[doc.docs.length - 1]) {
              this.lastVisible = doc.docs[doc.docs.length - 1]
            }
            $state.loaded()
          } else {
            $state.complete()
          }
        }
        // (error) => {
        //   console.log('error', error)
        // }
        )

      this.listeners.push(listener)
    },
    getMultiplier () {
      const listener = df.doc('project_constants/config').onSnapshot(doc => {
        this.config = doc.data()
        this.multiplier = doc.data().item_amount.decimal_multiplier
      })
      this.listeners.push(listener)
    }
  }
}
</script>
<style scoped>
/* Row body wrapper */
.discount-rows-body {
  background: #F5F7FA;
  padding: 6px 0 2px;
}

/* List View - Discount Cards */
.discount-card {
  border: 1px solid #EEF2F5 !important;
  border-left: 3px solid #E0E0E0 !important;
  border-radius: 6px !important;
  background: #ffffff !important;
  box-shadow: none !important;
  overflow: hidden !important;
  margin-bottom: 4px !important;
  transition: border-left-color 0.15s ease, border-color 0.15s ease, background 0.15s ease !important;
}

.discount-card:hover {
  border-color: #00BCD4 !important;
  background: #F8FAFB !important;
}

.discount-card.status-ok       { border-left-color: #4ADE80 !important; }
.discount-card.status-inactive { border-left-color: #E0E0E0 !important; }

.discount-row {
  padding: 12px 16px !important;
  min-height: 60px !important;
}

/* Status Text Colors */
.status-text-active {
  color: rgba(76, 175, 80, 1) !important;
}

.status-text-inactive {
  color: rgba(120, 120, 130, 1) !important;
}

/* Grid View - Discount Cards */
.discount-grid-card {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px) !important;
  border-radius: 16px !important;
  border: 1px solid rgba(0, 179, 190, 0.2) !important;
  box-shadow: 0 8px 32px rgba(0, 179, 190, 0.1) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  overflow: hidden;
}

.discount-grid-card:hover {
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 12px 48px rgba(0, 179, 190, 0.2) !important;
  border-color: rgba(0, 179, 190, 0.4) !important;
}

.discount-grid-header {
  position: relative;
  overflow: hidden;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

/* Status Headers - Grid View */
.status-active-header {
  background: linear-gradient(135deg,
    rgba(76, 175, 80, 0.5) 0%,
    rgba(56, 142, 60, 0.45) 50%,
    rgba(76, 175, 80, 0.5) 100%) !important;
}

.discount-grid-card:hover .status-active-header {
  background: linear-gradient(135deg,
    rgba(76, 175, 80, 0.65) 0%,
    rgba(56, 142, 60, 0.6) 50%,
    rgba(76, 175, 80, 0.65) 100%) !important;
}

.status-inactive-header {
  background: linear-gradient(135deg,
    rgba(120, 120, 130, 0.5) 0%,
    rgba(90, 90, 100, 0.45) 50%,
    rgba(120, 120, 130, 0.5) 100%) !important;
}

.discount-grid-card:hover .status-inactive-header {
  background: linear-gradient(135deg,
    rgba(120, 120, 130, 0.65) 0%,
    rgba(90, 90, 100, 0.6) 50%,
    rgba(120, 120, 130, 0.65) 100%) !important;
}

.discount-icon-wrapper {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.discount-grid-card:hover .discount-icon-wrapper {
  transform: scale(1.1);
}

.discount-grid-content {
  padding: 16px;
  min-height: 90px;
}

.discount-grid-title {
  font-size: 18px !important;
  font-weight: 600 !important;
  color: rgba(70, 70, 80, 0.9) !important;
  margin-bottom: 4px !important;
  letter-spacing: 0.3px !important;
}

.discount-grid-type {
  font-size: 14px !important;
  font-weight: 500 !important;
  color: rgba(70, 70, 80, 0.7) !important;
  margin-bottom: 4px !important;
}

.discount-grid-status {
  font-size: 14px !important;
  font-weight: 500 !important;
  margin-bottom: 4px !important;
}

.discount-grid-actions {
  padding: 8px 16px !important;
}

/* Font Weight */
.font-weight-medium {
  font-weight: 500 !important;
}

/* One Liner Text */
.one-liner-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.add-discount-btn {
  background: rgba(0, 188, 212, 0.08) !important;
  color: #00838F !important;
  border: 1.2px solid #00b3be !important;
  border-radius: 8px !important;
  height: 40px !important;
  min-height: 40px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 13px !important;
  padding: 0 16px !important;
  letter-spacing: 0.2px !important;
}
</style>
